import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AdministrativeTabs from './AdministrativeTabs'
import { useAdministrativeActionsModal } from '../../contexts/AdministrativeActionsModalContext'
import { useTranslation } from "react-i18next"

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: 0,
    paddingLeft: 24,
    paddingRight: 24,
  },
  '& .MuiDialogActions-root': {
    paddingTop: 0,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 32,
  },
}))

const AdministrativeActionsModal = ({ onSend, enableNotifications, enableAnnotations }) => {
  const {
    open,
    closeModal,
    validateDisabledButton,
    handleSendClick,
    selectedTab,
  } = useAdministrativeActionsModal()
  const { t } = useTranslation('common')

  const handleClick = () => {
    const currentTabType =
      enableNotifications && selectedTab === 0
        ? "notification"
        : "annotation"

    handleSendClick(currentTabType)
    onSend && onSend()
  }

  const isDisabled = () => {
    const currentTabType =
      enableNotifications && selectedTab === 0
        ? "notification"
        : "annotation"

    return validateDisabledButton(currentTabType)
  }

  return (
    <BootstrapDialog
      onClose={closeModal}
      aria-labelledby="adm-actions-title"
      open={open}
    >
      <DialogTitle id="adm-actions-title">{t('admin_actions_modal.title')}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeModal}
        sx={{ position: "absolute", right: 8, top: 8, color: "#000" }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <AdministrativeTabs
          enableNotifications={enableNotifications}
          enableAnnotations={enableAnnotations}
        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClick}
          variant="contained"
          disabled={isDisabled()}
        >
          Enviar
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}


export default AdministrativeActionsModal
